<template>
  <div class="service-wrapper">
    <el-form
      label-width="0"
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
    >
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item>
            <Multiselect
              :key="services.length"
              v-model="service_chosen"
              :options="services"
              :placeholder="$t('chose_service')"
              label="label"
              trackBy="label"
              valueProp="value"
              @select="setService"
              :searchable="true"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="description">
            <el-input
              :placeholder="$t('description_service')"
              maxlength="50"
              v-model="ruleForm.description"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <div>{{ $t("bg_color_service") }}</div>
            <el-color-picker
              v-model="bgColor"
              @active-change="BGColorChanged"
            ></el-color-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <div>{{ $t("text_color_service") }}</div>
            <el-color-picker
              v-model="textColor"
              @active-change="TextColorChanged"
            ></el-color-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <div>{{ $t("preview") }}</div>
            <div class="preview" :style="{ backgroundColor: bgColor }">
              <div class="time" :style="{ color: textColor }">15:23</div>
              <div class="title" :style="{ color: textColor }">
                {{ $t("service_title") }}
              </div>
              <div class="subtitle" :style="{ color: textColor }">
                {{ $t("service_subtitle") }}
              </div>
            </div>
          </el-form-item>
        </el-col>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="locationschooser">
              <MultiSelect
                v-model="location_restrictions"
                :options="locations"
                :filter="true"
                optionValue="idlocation"
                optionLabel="name"
                :placeholder="$t('locations_for_available')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-col :span="24">
          <el-form-item>
            <el-checkbox
              v-model="visible"
              :label="$t('visible_for_tenants')"
              border
            ></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item>
            <el-checkbox
              v-model="multiplelocation"
              :label="$t('multiple_locations')"
              border
            ></el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24" v-if="multiplelocation && !addGroupField">
        <el-col :span="14">
          <div class="subtitle">
            {{ $t("group_for_service") }}
          </div>
          <el-form-item prop="chosen_groups">
            <MultiSelect
              v-model="ruleForm.chosen_groups"
              :options="virtualgroups"
              :filter="true"
              optionValue="idvirtualgroup"
              optionLabel="name"
              :placeholder="$t('chose_group')"
            />
          </el-form-item>
        </el-col>

        <el-col :span="10" style="padding-top:40px;" v-if="!addGroupField">
          <el-button
            type="primary"
            icon="el-icon-plus"
            circle
            @click="addGroupBtn"
          ></el-button>
        </el-col>
      </el-row>

      <el-row :gutter="24" v-if="multiplelocation && addGroupField">
        <el-col :span="24">
          <div class="subtitle">{{ $t("add_group") }}</div>
          <el-form-item>
            <el-input
              minlength="1"
              :placeholder="$t('group_name')"
              v-model="new_group_name"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <MultiSelect
              v-model="new_group_cities"
              :options="locations"
              :filter="true"
              optionValue="idlocation"
              optionLabel="name"
              :placeholder="$t('locations_for_group')"
            />
          </el-form-item>
          <el-form-item>
            <el-button plain type="primary" round @click="addGroup">{{
              $t("create")
            }}</el-button>
            <el-button plain round type="danger" @click="cancelAddGroup">{{
              $t("cancel")
            }}</el-button>
          </el-form-item>

          <hr style="margin-bottom: 24px;" />
        </el-col>
      </el-row>

      <el-form-item>
        <el-button
          plain
          round
          @click="$emit('delete-index', index)"
          type="danger"
          >{{ $t("delete_service") }}</el-button
        >
        <el-button
          round
          plain
          type="primary"
          @click="submitForm('ruleForm')"
          v-if="!idserviceType"
          >{{ $t("create_service") }}</el-button
        >
        <el-button
          plain
          round
          type="primary"
          @click="submitChangeForm('ruleForm')"
          v-if="idserviceType"
          >{{ $t("edit_service") }}</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<style lang="scss" scoped>
::v-deep(.multiselect) {
  .multiselect-option,
  .multiselect-single-label {
    line-height: 16px;
  }
}

.p-multiselect {
  width: 100%;
  border-radius: 35px;
  padding-left: 24px;
  height: 44px;

  :deep(.p-multiselect-label) {
    padding: 0;
  }
}

.preview {
  padding: 12px 24px;
  height: 100px;
  position: relative;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  outline: none;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;

  .title,
  .subtitle {
    line-height: 14px;
  }

  .title {
    font-size: 15px;
  }

  .subtitle {
    font-size: 13px;
  }

  .time {
    position: absolute;
    right: 12px;
    top: 6px;
  }
}

.subtitle {
  font-size: 15px;
  color: $gkt-orange-rgba;
  margin-bottom: 12px;
}
</style>

<script>
import { provide } from "vue";
import store from "@/store";
import MultiSelect from "primevue/multiselect";
import Multiselect from "@vueform/multiselect";

export default {
  name: "service",
  components: {
    MultiSelect,
    Multiselect
  },
  props: {
    idservicetype: Number,
    serviceData: Object,
    index: Number
  },
  setup() {
    provide("store", store);
  },
  data() {
    var validateChosenGroups = (rule, value, callback) => {
      if (!value.length && this.multiplelocation) {
        callback(new Error(this.$t("select_group_or_create")));
      } else {
        if (this.ruleForm.chosen_groups.length > 0 && this.multiplelocation) {
          this.$refs.ruleForm.validateField("chosen_groups");
        }
        callback();
      }
    };

    var validateDescription = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("enter_description")));
      } else {
        if (this.ruleForm.description !== "") {
          this.$refs.ruleForm.validateField("description");
        }
        callback();
      }
    };

    return {
      services:
        store.state.language == "en"
          ? require("@/default_services/en").default
          : require("@/default_services/de").default,
      service_chosen: "",
      errors: "",
      ruleForm: {
        chosen_groups: [],
        description: ""
      },
      addGroupField: false,
      rules: {
        description: [{ validator: validateDescription, trigger: "blur" }],
        chosen_groups: [{ validator: validateChosenGroups, trigger: "blur" }]
      },
      bgColor: null,
      textColor: null,
      visible: true,
      multiplelocation: false,
      new_group_name: "",
      new_group_cities: [],
      location_restrictions: [],
      chosen_groups: [],
      locations: [],
      virtualgroups_mapping: [],
      assigned_service: [],
      virtualgroups: [],
      idserviceType: null
    };
  },
  beforeMount() {
    const d = this.serviceData;
    this.bgColor = d.bcolor ?? this.bgColor;
    this.textColor = d.fcolor ?? this.textColor;
    this.multiplelocation = d.multiplelocation == 1 ? true : false;
    this.visible = d.visible == 1 || d.visible ? true : false;
    this.ruleForm.description = d.name ?? "";
    this.idserviceType = d.idserviceType ?? null;
    this.location_restrictions = d.onlocations;
  },
  emits: ["update-services", "delete-index", "update-providers"],
  methods: {
    setService() {
      this.ruleForm.description = this.service_chosen;
    },
    addGroupBtn() {
      this.addGroupField = true;
    },
    cancelAddGroup() {
      this.addGroupField = false;
    },
    async addGroup() {
      const name = this.new_group_name;
      const cities = this.new_group_cities;

      if (name == "") {
        this.$message({
          showClose: true,
          message: this.$t("enter_group_name"),
          type: "error",
          offset: 350,
          duration: 20000
        });
      } else if (
        this.virtualgroups.find(function(group) {
          return group.name == name;
        })
      ) {
        this.$message({
          showClose: true,
          message: this.$t("duplicate_group_name"),
          type: "error",
          offset: 350
        });
      } else {
        const response = await store.methods.apiRequest("addVirtualGroup", {
          name: name
        });

        const res = response.data;

        if (res.status == "success") {
          if (cities.length > 0) {
            await store.methods.apiRequest("setVGroupLocations", {
              idvirtualgroup: res.results.idvirtualgroup,
              locations: cities
            });

            this.addGroupField = false;
          }

          this.$message({
            showClose: true,
            message: this.$t("location_group_created"),
            type: "success",
            offset: 350
          });

          this.new_group_name = "";
          this.new_group_cities = [];

          this.getVirtualGroups();
        } else {
          this.$message({
            showClose: true,
            message: res.errordetails,
            type: "error",
            offset: 350
          });
        }
      }
    },
    TextColorChanged: function(color) {
      if (color == null) color = "#ffffff";
      if (color == "") color = "#ffffff";
      this.textColor = color;
    },
    BGColorChanged: function(color) {
      if (color == null) color = "#E18324";
      if (color == "") color = "#E18324";
      this.bgColor = color;
    },
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          if (this.serviceData.idprovider) {
            this.addService();
            this.$emit("update-providers");
          } else {
            this.$emit("update-services", this.returnServiceData());
          }
        } else {
          return false;
        }
      });
    },
    submitChangeForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const visible = this.visible ? 1 : 0;
          const multipleloc = this.multiplelocation ? 1 : 0;

          const response = await store.methods.apiRequest("changeservice", {
            name: this.ruleForm.description,
            fcolor: this.textColor,
            bcolor: this.bgColor,
            visible: visible,
            multiplelocation: multipleloc,
            idprovider: this.serviceData.idprovider,
            idservicetype: this.idserviceType,
            onlocations: this.location_restrictions
          });

          const res = response.data;

          const response2 = await store.methods.apiRequest(
            "mapVirtualGroupToService",
            {
              idvirtualgroups: this.ruleForm.chosen_groups,
              idservicetype: this.idserviceType
            }
          );

          if (res.status == "success" && response2.data.status == "success") {
            this.$message({
              showClose: true,
              message: this.$t("service_updated"),
              type: "success",
              offset: 350
            });

            this.$emit("update-providers");
          } else {
            this.$message({
              showClose: true,
              message: res.errordetails,
              type: "error",
              offset: 350
            });
          }
        } else {
          return false;
        }
      });
    },
    async addService() {
      const visible = this.visible ? 1 : 0;
      const multipleloc = this.multiplelocation ? 1 : 0;

      const response = await store.methods.apiRequest("addservice", {
        name: this.ruleForm.description,
        fcolor: this.textColor,
        bcolor: this.bgColor,
        visible: visible,
        multiplelocation: multipleloc,
        idprovider: this.serviceData.idprovider,
        onlocations: this.location_restrictions
      });

      const res = response.data;

      if (res.status == "success") {
        this.$message({
          showClose: true,
          message: this.$t("service_created"),
          type: "success",
          offset: 350
        });

        this.idserviceType = res.results.idservicetype;
        this.$emit("update-services", this.returnServiceData());
        this.$emit("update-providers");
      } else {
        this.$message({
          showClose: true,
          message: res.errordetails,
          type: "error",
          offset: 350
        });
      }
    },
    returnServiceData() {
      const newData = Object.assign({}, this.serviceData);
      newData.description = this.ruleForm.description;
      newData.name = this.ruleForm.description;
      newData.idserviceType = this.idserviceType;
      newData.bgColor = this.bgColor;
      newData.textColor = this.textColor;
      newData.visible = this.visible;
      newData.multiplelocation = this.multiplelocation;
      newData.chosen_groups = this.ruleForm.chosen_groups;
      newData.location_restrictions = this.location_restrictions;
      return newData;
    },
    changeDescription() {
      const newData = Object.assign({}, this.serviceData);
      newData.description = this.ruleForm.description;

      this.$emit("update-services", newData);
    },
    async getVirtualGroups() {
      const response = await store.methods.apiRequest("getDataVirtualGroup");
      const res = response.data;

      if (res.errordetails) {
        console.log("error", res.errordetails);
      }

      if (res.results && res.results.assigned_service) {
        if (this.idserviceType) {
          const serviceType = this.idserviceType;

          let groups = res.results.assigned_service.filter(function(item) {
            return serviceType == item.idservicetype;
          });

          this.ruleForm.chosen_groups = groups.map(function(item) {
            return item.idvirtualgroups;
          });
        }
      }

      if (res.results && res.results.virtualgroups) {
        this.virtualgroups = res.results.virtualgroups;
      }

      if (res.results && res.results.virtualgroups_mapping) {
        this.virtualgroups_mapping = res.results.virtualgroups_mapping;
      }

      if (res.results && res.results.locations) {
        this.locations = res.results.locations[0];
      }
    },
    async getColors() {
      const response = await store.methods.apiRequest("getsettings");
      const res = response.data;

      if (res.errordetails) {
        console.log("error", res.errordetails);
      }

      if (res.results && res.results.fgcolor && res.results.bgcolor) {
        this.bgColor = this.bgColor
          ? this.bgColor
          : res.results.service_bgcolor;
        this.textColor = this.textColor
          ? this.textColor
          : res.results.service_fgcolor;
      }
    },
    async getProviders() {
      const response = await store.methods.apiRequest("getproviders");
      const res = response.data;
      let services = this.services;

      if (res.errordetails) {
        console.log("error", res.errordetails);
      }

      if (res.results && res.results.providers) {
        res.results.providers.forEach(function(provider) {
          provider.servicetypes.forEach(function(s) {
            const idx = services.find(function(item) {
              return item.value == s.name;
            });

            if (!idx) {
              services.push({
                label: s.name,
                value: s.name
              });
            }
          });
        });

        this.services = services;
      }
    }
  },
  async mounted() {
    this.getVirtualGroups();
    this.getProviders();
    this.getColors();
  }
};
</script>
